import { general } from './general';
import { branch } from './branch';
import { collection } from './collection';
import { country } from './country';
import { location } from './location';
import { notapplicable } from './notapplicable';
import { datecontrol } from './datecontrol';
import { daterange } from './daterange';
import { email } from './email';
import { foreignborndocument } from './foreignborndocument';
import { name } from './name';
import { ssn } from './ssn';
import { telephone } from './telephone';
import { physicaladdress } from './physicaladdress';
import { text } from './text';
import { textarea } from './textarea';
import { radio } from './radio';

const civilunion = (data = {}) => general('civilunion', {
  Address: location(data.Address),
  AlternateAddress: physicaladdress(data.AlternateAddress),
  AddressSeparated: location(data.AddressSeparated),
  AddressSeparatedNotApplicable: notapplicable(data.AddressSeparatedNotApplicable),
  BirthPlace: location(data.BirthPlace),
  Birthdate: datecontrol(data.Birthdate),
  Citizenship: country(data.Citizenship),
  DateSeparated: datecontrol(data.DateSeparated),
  Divorced: branch(data.Divorced),
  Email: email(data.Email),
  EmailNotApplicable: notapplicable(data.EmailNotApplicable),
  EnteredCivilUnion: datecontrol(data.EnteredCivilUnion),
  ForeignBornDocument: foreignborndocument(data.ForeignBornDocument),
  ForeignBornDocumentCivil: foreignborndocument(data.ForeignBornDocumentCivil), // pvq only
  GovOffice: text(data.GovOffice), // pvq only
  Location: location(data.Location),
  Name: name(data.Name),
  OtherNames: collection(
    ((data.OtherNames || {}).items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          Has: branch(yitem.Has),
          Name: name(yitem.Name),
          MaidenName: branch(yitem.MaidenName),
          DatesUsed: daterange(yitem.DatesUsed),
          NameOptions: radio(yitem.NameOptions), // pvq only
          NameOptionsExplanation: textarea(yitem.NameOptionsExplanation), // pvq only
          DatesNotApplicable: notapplicable(yitem.DatesNotApplicable), // pvq only
        },
      };
    })
  ),
  SameAddress: branch(data.SameAddress), // PVQ only
  SpouseAddress: location(data.SpouseAddress), // PVQ only
  SSN: ssn(data.SSN),
  Separated: branch(data.Separated),
  Telephone: telephone(data.Telephone),
  UseCurrentAddress: notapplicable(data.UseCurrentAddress),
  UseApplicantPhoneNotApplicable: notapplicable(data.UseApplicantPhoneNotApplicable),
  Comments: textarea(data.Comments),
  ContinueComments: textarea(data.ContinueComments),
  SeparatedComments: textarea(data.SeparatedComments),
  SeparationComments: textarea(data.SeparationComments),
  AnswerComments: textarea(data.AnswerComments),
  AddressComments: textarea(data.AddressComments),
  PhysicalLocationComments: textarea(data.PhysicalLocationComments),
});

export { civilunion };
export default civilunion;
